import React from "react";
import { imageUrl } from "../../constant/BaseUrl";
import { setSelectedSymbol } from "../../../redux/watchlistSlice";
import { useDispatch } from "react-redux";
import { formatDecimal } from "../../../util/decimalFormatter";
const WatchlistRow = ({
  symbol,
  bid,
  ask,
  isDefault,
  icon,
  change,
  active,
  segment,
  removeWatchListSymbol,
  isUpdating,
  stepSize,
  sellCommission,
  buyCommission,
  commissionType,
  priceStep,
  contractSize,
}) => {
  const dispatch = useDispatch();
  return (
    <tr
      className={`ng-scope ${active ? "active" : ""}`}
      onClick={() => {
        dispatch(
          setSelectedSymbol({
            symbol,
            segment,
            sellCommission,
            buyCommission,
            commissionType,
            stepSize,
            priceStep,
            contractSize,
          })
        );
      }}
    >
      <td>
        {icon ? (
          <img
            className="currency_icon"
            src={imageUrl + "/static/currencyImage/" + icon}
            alt=""
          />
        ) : null}
        <span className="fw500">{symbol}</span>
      </td>
      <td className="text-right">
        {formatDecimal(bid, priceStep, { symbol: false })}
      </td>
      <td className="text-right">
        {formatDecimal(ask, priceStep, { symbol: false })}
      </td>
      <td className="text-right">
        <span className={change > 0 ? "text-success" : "text-danger"}>
          {change}
        </span>
      </td>
      {!isDefault ? (
        isUpdating && active ? (
          <i className="bi">
            <span
              className="loading-spin"
              style={{
                color: "rgb(0, 188, 139)",
                cursor: "pointer",
              }}
            >
              <div className="loader" style={{ display: "inline-block" }}></div>
            </span>
          </i>
        ) : (
          <i
            className="bi bi-trash3 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              removeWatchListSymbol(symbol, "remove", segment);
            }}
          ></i>
        )
      ) : null}
    </tr>
  );
};

// ✅ Custom memoization check: only re-render if key props change
function areEqual(prev, next) {
  return (
    prev.bid === next.bid &&
    prev.ask === next.ask &&
    prev.change === next.change &&
    prev.active === next.active
  );
}

export default React.memo(WatchlistRow, areEqual);
